/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateGoodsStatusBatchVo
 */
export interface UpdateGoodsStatusBatchVo {
    /**
     * 商品ID列表
     * @type {Array<number>}
     * @memberof UpdateGoodsStatusBatchVo
     */
    goodsIds?: Array<number>;
    /**
     * 商品状态 1 预计入库 2 部分入库 3 入库完成 4 运输中 5 错误入库 6 申请取消 7 废弃
     * @type {number}
     * @memberof UpdateGoodsStatusBatchVo
     */
    status?: number;
}

/**
 * Check if a given object implements the UpdateGoodsStatusBatchVo interface.
 */
export function instanceOfUpdateGoodsStatusBatchVo(value: object): value is UpdateGoodsStatusBatchVo {
    return true;
}

export function UpdateGoodsStatusBatchVoFromJSON(json: any): UpdateGoodsStatusBatchVo {
    return UpdateGoodsStatusBatchVoFromJSONTyped(json, false);
}

export function UpdateGoodsStatusBatchVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGoodsStatusBatchVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsIds': json['goodsIds'] == null ? undefined : json['goodsIds'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function UpdateGoodsStatusBatchVoToJSON(json: any): UpdateGoodsStatusBatchVo {
    return UpdateGoodsStatusBatchVoToJSONTyped(json, false);
}

export function UpdateGoodsStatusBatchVoToJSONTyped(value?: UpdateGoodsStatusBatchVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsIds': value['goodsIds'],
        'status': value['status'],
    };
}

